import {
  ADD_BILLINGCONSOLIDATEDINVOICE,
  ADD_BILLINGGENERATEINVOICE,
  ADD_BILLINGREQUESTAPPROVAL,
  GET_BILLINGCONSOLIDATEDINVOICE,
  GET_BILLINGEXTRACHARGECALCULATION,
  GET_BILLINGINVOICEDETAILS,
  GET_BILLINGLIST,
  GET_BILLINGPRICEDETAILS,
  GET_CONSOLIDATE_INVOICE_MATRIX,
  GET_FINAL_INVOICE,
  ADD_BILLINGREQUESTAPPROVALLINK,
  GENERATE_CONSOLIDATED_PAYMENT_LINK,
  GET_CONSOLIDATED_PAYMENT_LINK,
  CHECK_CONSOLIDATED_PAYMENT_STATUS,
  CANCEL_CONSOLIDATED_PAYMENT_LINK,
  PATCH_INVOICE_TAXES,
  SEND_CONSOLIDATED_INVOICE_EMAIL,
  GET_BILLING_EMPLOYEES,
  GET_BILL_SELF_ELIGIBLE_INVOICES,
  GENERATE_BILL_SELF_CONSOLIDATED_INVOICE,
  GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST,
  GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS,
} from "resources/actionTypes";

const initialState = {
  billingList: [],
  loading: false,
};

const initialBillingInvoiceState = {
  bilingInvoiceDetails: "",
  loading: false,
};

const initialBillingApprovalState = {
  bilingApprovalRequest: "",
  loading: false,
};

const initialConsolidatedInvoiceState = {
  bilingConsolidatedInvoice: "",
  loading: false,
};

const initialBillingGenerateInvoiceState = {
  billingInvoice: "",
  loading: false,
};

const initialBillingPriceDetailsState = {
  bilingPriceDetails: "",
  loading: false,
};

const initialBillingChargesCalculationState = {
  chargesCalculations: "",
  loading: false,
};
const intialConsildateInvoiceMatrixState = {
  consolidateInvoiceMatrix: "",
  loading: false,
};
const intialFinalInvoiceState = {
  getFinalInvoice: "",
  loading: false,
};

const initialBillingApprovalLinkState = {
  bilingApprovalRequestLink: "",
  loading: false,
};
const initialPaymentLinkState = {
  loading: false,
  error: null,
  data: null, // Will hold: { paymentLink, paymentLinkStatus, paymentStatus, qrCode, expiryTime }
};
export const getBillingList = (state = initialState, action) => {
  switch (action.type) {
    case GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGLIST.GET_BILLINGLIST_SUCCESS:
      return {
        ...state,
        billingList: action.billingList,
        loading: false,
      };
    case GET_BILLINGLIST.GET_BILLINGLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_BILLINGLIST.GET_BILLINGLIST_CLEARED:
      return {
        ...state,
        loading: false,
        billingList: "",
      };
    default:
      return state;
  }
};
export const consolidatedPaymentLinkReducer = (
  state = initialPaymentLinkState,
  action,
) => {
  switch (action.type) {
    case GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_REQUESTED:
    case GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_REQUESTED:
    case CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_REQUESTED:
    case CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_REQUESTED:
      return { ...state, loading: true };

    case GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_SUCCESS:
    case GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_SUCCESS:
    case CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_SUCCESS:
    case CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GENERATE_CONSOLIDATED_PAYMENT_LINK.GENERATE_CONSOLIDATED_PAYMENT_LINK_FAILED:
    case GET_CONSOLIDATED_PAYMENT_LINK.GET_CONSOLIDATED_PAYMENT_LINK_FAILED:
    case CHECK_CONSOLIDATED_PAYMENT_STATUS.CHECK_CONSOLIDATED_PAYMENT_STATUS_FAILED:
    case CANCEL_CONSOLIDATED_PAYMENT_LINK.CANCEL_CONSOLIDATED_PAYMENT_LINK_FAILED:
      return { ...state, loading: false, error: action.message };

    default:
      return state;
  }
};
export const getBillingInvoiceDetails = (
  state = initialBillingInvoiceState,
  action,
) => {
  switch (action.type) {
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_SUCCESS:
      return {
        ...state,
        bilingInvoiceDetails: action.billingInvoiceDetails,
        loading: false,
      };
    case GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingGenerateInvoice = (
  state = initialBillingGenerateInvoiceState,
  action,
) => {
  switch (action.type) {
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_SUCCESS:
      return {
        ...state,
        billingInvoice: action.billingInvoice,
        loading: false,
      };
    case ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingChargesCalculations = (
  state = initialBillingChargesCalculationState,
  action,
) => {
  switch (action.type) {
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_SUCCESS:
      return {
        ...state,
        chargesCalculations: action.chargesCalculations,
        loading: false,
      };
    case GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingPriceDetails = (
  state = initialBillingPriceDetailsState,
  action,
) => {
  switch (action.type) {
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_SUCCESS:
      return {
        ...state,
        bilingPriceDetails: action.billingPriceDetails,
        loading: false,
      };
    case GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const addBillingRequestApproval = (
  state = initialBillingApprovalState,
  action,
) => {
  switch (action.type) {
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_SUCCESS:
      return {
        ...state,
        bilingApprovalRequest: action.billingRequest,
        loading: false,
      };
    case ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const addBillingConsolidatedInvoice = (
  state = initialConsolidatedInvoiceState,
  action,
) => {
  switch (action.type) {
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS:
      return {
        ...state,
        bilingConsolidatedInvoice: action.billingConsolidatedRequest,
        loading: false,
      };
    case ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBillingConsolidatedInvoiceDetails = (
  state = initialConsolidatedInvoiceState,
  action,
) => {
  switch (action.type) {
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS:
      return {
        ...state,
        bilingConsolidatedInvoice: action.billingConsolidatedInvoice,
        loading: false,
      };
    case GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getConsolidateInvoiceMatrix = (
  state = intialConsildateInvoiceMatrixState,
  action,
) => {
  switch (action.type) {
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS:
      return {
        ...state,
        consolidateInvoiceMatrix: action.consolidateInvoiceMatrix,
        loading: false,
      };
    case GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getFinalInvoice = (state = intialFinalInvoiceState, action) => {
  switch (action.type) {
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        getFinalInvoice: action.finalInvoiceData,
      };
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_FINAL_INVOICE.GET_FINAL_INVOICE_CLEARED:
      return {
        ...state,
        loading: false,
        getFinalInvoice: "",
      };
    default:
      return state;
  }
};

// Billing Request Approval Link
export const addBillingRequestApprovalLink = (
  state = initialBillingApprovalLinkState,
  action,
) => {
  switch (action.type) {
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS:
      return {
        ...state,
        bilingApprovalRequestLink: action.billingRequest,
        loading: false,
      };
    case ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

const initialPatchInvoiceTaxesState = {
  loading: false,
  success: false,
  error: null,
};

export const patchInvoiceTaxesReducer = (
  state = initialPatchInvoiceTaxesState,
  action,
) => {
  switch (action.type) {
    case PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case PATCH_INVOICE_TAXES.PATCH_INVOICE_TAXES_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.message,
      };
    default:
      return state;
  }
};

const initialSendConsolidatedEmailState = {
  loading: false,
  success: false,
  error: null,
};

export const sendConsolidatedInvoiceEmailReducer = (
  state = initialSendConsolidatedEmailState,
  action,
) => {
  switch (action.type) {
    case SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_SUCCESS:
      return { ...state, loading: false, success: true };
    case SEND_CONSOLIDATED_INVOICE_EMAIL.SEND_CONSOLIDATED_INVOICE_EMAIL_FAILED:
      return { ...state, loading: false, success: false, error: action.message };
    default:
      return state;
  }
};

const initialBillingEmployeesState = {
  employees: [],
  loading: false,
  error: null,
};

export const getBillingEmployeesReducer = (state = initialBillingEmployeesState, action) => {
  switch (action.type) {
    case GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_REQUESTED:
      return { ...state, loading: true, error: null };
    case GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_SUCCESS:
      return { ...state, loading: false, employees: action.payload };
    case GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_BILLING_EMPLOYEES.GET_BILLING_EMPLOYEES_CLEAR:
      return { ...state, employees: [] };
    default:
      return state;
  }
};

const initialBillSelfEligibleInvoicesState = {
  eligibleInvoices: [],
  loading: false,
  error: null,
};

export const getBillSelfEligibleInvoicesReducer = (state = initialBillSelfEligibleInvoicesState, action) => {
  switch (action.type) {
    case GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_REQUESTED:
      return { ...state, loading: true, error: null };
    case GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_SUCCESS:
      return { ...state, loading: false, eligibleInvoices: action.payload };
    case GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_BILL_SELF_ELIGIBLE_INVOICES.GET_BILL_SELF_ELIGIBLE_INVOICES_CLEAR:
      return { ...state, eligibleInvoices: [] };
    default:
      return state;
  }
};

const initialGenerateBillSelfState = {
  loading: false,
  success: false,
  error: null,
};

export const generateBillSelfConsolidatedInvoiceReducer = (state = initialGenerateBillSelfState, action) => {
  switch (action.type) {
    case GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_REQUESTED:
      return { ...state, loading: true, success: false, error: null };
    case GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_SUCCESS:
      return { ...state, loading: false, success: true };
    case GENERATE_BILL_SELF_CONSOLIDATED_INVOICE.GENERATE_BILL_SELF_CONSOLIDATED_INVOICE_FAILED:
      return { ...state, loading: false, success: false, error: action.message };
    default:
      return state;
  }
};

const initialBillSelfListState = {
  consolidatedInvoicesList: [],
  loading: false,
  error: null,
};

export const getBillSelfConsolidatedInvoicesListReducer = (state = initialBillSelfListState, action) => {
  switch (action.type) {
    case GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_REQUESTED:
      return { ...state, loading: true, error: null };
    case GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_SUCCESS:
      return { ...state, loading: false, consolidatedInvoicesList: action.payload };
    case GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_FAILED:
      return { ...state, loading: false, error: action.message };
    case GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST.GET_BILL_SELF_CONSOLIDATED_INVOICES_LIST_CLEAR:
      return { ...state, consolidatedInvoicesList: [] };
    default:
      return state;
  }
};

const initialBillSelfDetailsState = {
  consolidatedInvoiceDetails: null,
  loading: false,
  error: null,
};

export const getBillSelfConsolidatedInvoiceDetailsReducer = (state = initialBillSelfDetailsState, action) => {
  switch (action.type) {
    case GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_REQUESTED:
      return { ...state, loading: true, error: null };
    case GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_SUCCESS:
      return { ...state, loading: false, consolidatedInvoiceDetails: action.payload };
    case GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS.GET_BILL_SELF_CONSOLIDATED_INVOICE_DETAILS_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};
